<template>
	<div
		v-if="post || comment || message"
		class="d-flex align-center post-reactions"
	>

		<template v-for="(reaction, i) in reactionsIcons">
			<div
				v-bind:key="'reaction-' + i"
				v-show="reaction.display"
				@click="showUsersReactions()"
				:class="[
					{
						'post-reaction--pinned' : (post) ? post.is_pinned : false,
						'post-reaction--appended' : reaction.appended
					}, reaction.color, 'post-reaction cursor-pointer']"
			>
				<v-icon class="white--text font-14 font-weight-bold">
					{{ reaction.icon }}
				</v-icon>
			</div>
		</template>
		<div v-if="post" :key="postKey" class="ml-2 cursor-pointer" @click="showUsersReactions()">
			{{ text }}
		</div>
		<div v-if="comment" class="font-12 ml-2 cursor-pointer" @click="showUsersReactions()">
			{{ comment.reactions_count }}
		</div>
		<post-users-reactions-dialog
			v-if="reactionsDialogCreated"
			ref="reactions-dialog"
			:post="post"
			:comment="comment"
			:reactions="reactionsIcons"
			:message="message"
		/>
	</div>
</template>

<script>
import {wordSpelling} from "@/functions/wordSpelling";
import PostUsersReactionsDialog from "@/components/wall/post/PostUsersReactionsDialog";

export default {
	name: "PostReactionIcons",
	components: {
		PostUsersReactionsDialog
	},
	props: {
		post: {
			type: Object,
			default: null
		},
		comment: {
			type: Object,
			default: null
		},
		message: {
			type: Object,
			default: null
		}
	},
	data () {
		return {
			postKey: 0,
			reactionsDialogCreated: false,
			reactionsIcons: [
				{
					icon: '$like-small',
					iconLarge: '$like',
					color: 'success',
					type: 'like',
					display: false,
					appended: false
				},
				{
					icon: '$heart',
					iconLarge: '$heart-reaction',
					color: 'warning',
					type: 'love',
					display: false,
					appended: false
				},
				{
					icon: '$face-reaction-sm',
					iconLarge: '$face-reaction',
					color: 'gold',
					type: 'happy',
					display: false,
					appended: false
				},
				{
					icon: '$applause-reaction-sm',
					iconLarge: '$applause-reaction',
					color: 'blue',
					type: 'applause',
					display: false,
					appended: false
				}
			]
		}
	},
	watch: {
		'post.reactions': function() {
			this.checkIcons();
		},
		'post.my_reaction.type': {
			handler() {
				this.checkIcons()
			},
			deep: true
		},
		'comment.my_reaction': {
			handler() {
				this.checkIcons()
			},
			deep: true
		},
		'message.my_reaction': {
			handler() {
				this.checkIcons()
			},
			deep: true
		},
	},
	computed: {
		text() {
			let text = '', counter = this.post.reactions_count - 1
			if (this.post.my_reaction)
				text += 'Ty'
			else if (this.post.reactions && this.post.reactions.length > 0)
				text += (this.post.reactions[0].user.name) ? this.post.reactions[0].user.name : this.post.reactions[0].user.email
			if (counter > 0)
				text += ' i ' + counter + ' ' + wordSpelling('person', counter) + ' ' + wordSpelling('react', counter)
			else if (this.post.my_reaction && counter === 0)
				text += ' zareagowałeś/aś'
			return text
		}
	},
	created() {
		this.checkIcons()
	},
	methods: {
		checkIcons() {
			for (let i in this.reactionsIcons) {
				let object = null;
				if(this.post) {
					object = this.post;
				}
				else if(this.comment) {
					object = this.comment;
				}
				else if(this.message) {
					object = this.message
				}

				let count = object['reactions_' + this.reactionsIcons[i].type + '_count'],
					display = (count > 0)

				this.reactionsIcons[i].appended = !this.reactionsIcons[i].display && display
				this.reactionsIcons[i].display = display
			}
			this.postKey++;
		},
		showUsersReactions() {
			this.reactionsDialogCreated = true
			this.$nextTick(function () {
				this.$refs['reactions-dialog'].showDialog()
			})
		},
		renderText() {

		}
	}
}
</script>

<style lang="scss">
.post-reaction {
	height: 20px;
	width: 20px;
	border-radius: 100%;
	position: relative;
	outline: solid 2px;
	&--pinned {
		outline-color: var(--v-accent-lighten2);
	}
	&:not(&--pinned) {
		outline-color: var(--v-background-lighten1);
	}
	&--appended {
		animation-name: post-reaction-pinned-animation;
		animation-duration: 500ms;
	}
	.v-icon {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		svg {
			width: 14px;
		}
	}
	&:not(:first-child) {
		margin-left: -3px;

	}
}

@keyframes post-reaction-pinned-animation {
	0% {
		transform: scale(1.5);
	}
	100% {
		transform: scale(1);
	}
}
</style>
